var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMakeup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.25C8.82436 5.25 6.25 7.82436 6.25 11C6.25 11.2207 6.26243 11.4385 6.28664 11.6527L9.46967 8.46967C9.76256 8.17678 10.2374 8.17678 10.5303 8.46967C10.8232 8.76256 10.8232 9.23744 10.5303 9.53033L6.73828 13.3224C7.63065 15.3412 9.6508 16.75 12 16.75C15.1756 16.75 17.75 14.1756 17.75 11C17.75 10.7793 17.7376 10.5615 17.7134 10.3473L14.5303 13.5303C14.2374 13.8232 13.7626 13.8232 13.4697 13.5303C13.1768 13.2374 13.1768 12.7626 13.4697 12.4697L17.2617 8.67762C16.3694 6.65879 14.3492 5.25 12 5.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34267 18C4.30367 16.35 3 13.8273 3 11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11C21 13.8273 19.6963 16.35 17.6573 18H20C20.5523 18 21 18.4477 21 19C21 20.6569 19.6569 22 18 22H6C4.34315 22 3 20.6569 3 19C3 18.4477 3.44772 18 4 18H6.34267ZM10.1056 18H13.8944C16.9797 17.167 19.25 14.3486 19.25 11C19.25 6.99594 16.0041 3.75 12 3.75C7.99594 3.75 4.75 6.99594 4.75 11C4.75 14.3486 7.02027 17.167 10.1056 18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeup);
export default __webpack_public_path__ + "static/media/makeup.a14293d7c3a749515824b6e66c81b3cc.svg";
export { ForwardRef as ReactComponent };